// Change to Production before pushing

// Local Configuration
// export const DEFAULT_LOGIN_PAGE_URL = "http://localhost:5173"
// export const DEFAULT_AUTHORIZATION_SERVER_URL = "http://localhost:3013"

export const DEFAULT_LOGIN_PAGE_URL = "https://kunji.prathamvaidya.in/login"
export const DEFAULT_AUTHORIZATION_SERVER_URL = "https://api.prathamvaidya.in"